import { useSelector } from 'react-redux';
import { selectWeaveUserAcls } from 'redux/actions/auth/auth.selectors';
import { CoreACLs } from 'redux/actions/auth/auth.types';

export const useWeaveVerifyPermittedACL = () => {
  return useSelector(selectWeaveUserAcls)?.indexOf(CoreACLs.WEAVEVERIFYPERMITTED) >= 0;
};
